import React, { useContext, Fragment, useState } from 'react';
import loadable from '@loadable/component';
import Modal from '../Modal';
import Animation from '../Animation';
import SlideInCard from '../SlideInCard';
import RoundButton from '../RoundButton';
import quoteSubmitted from '../../animations/quoteSubmitted.json';
import { Context } from '../../context/AppContext';
import { MODALS } from '../../constants';
import FullScreenLoader from '../FullScreenLoader';

const Form = loadable(() => import('./QuoteForm'), {
  fallback: <FullScreenLoader />,
});

const QuoteForm = ({ defaults = {} }) => {
  const modalName = MODALS.QUOTE_FORM;

  const {
    media: { mobile },
    modal: { showModal, modals },
    user: { userContactDetails },
  } = useContext(Context);

  const { data = {} } = modals[modalName];

  const [slideInShow, setSlideInShow] = useState(false);

  return (
    <Fragment>
      <Modal
        name={modalName}
        onClickOutside={() => showModal(MODALS.MODAL_CONFIRMATION)}
      >
        <Form
          data={{ ...defaults, ...data, ...userContactDetails }}
          slideInShow={slideInShow}
          setSlideInShow={setSlideInShow}
        />
      </Modal>
      <SlideInCard
        show={slideInShow}
        title="Quote requests sent!"
        message="You should be hearing from local businesses soon."
        setShow={setSlideInShow}
        icon={
          <Animation
            animation={quoteSubmitted}
            loop={false}
            height={mobile ? 150 : 100}
            width={mobile ? 150 : 130}
          />
        }
      >
        <RoundButton
          onClick={() => setSlideInShow(false)}
          style={{ width: '110px' }}
          theme="outlineGrey"
        >
          Return
        </RoundButton>
      </SlideInCard>
    </Fragment>
  );
};

export default QuoteForm;
